<template>
    <div>
        <div
            v-if="loaded"
            class="pb-32 bg-gray-800"
        >
            <nav-bar></nav-bar>
        </div>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
import NavBar from "../components/core/NavBar.vue";

export default {
    data: () => {
        return {
            loaded: false
        };
    },
    components: {
        NavBar
    },

    async created() {
        await this.$store.dispatch("app/USER");
        this.loaded = true;
        //setInterval(() => this.$store.dispatch("auth/REFRESH"), 1000 * 60 * 3);
    }
};
</script>
